(function () {
  var root = document.querySelector('.wld-p-root');
  if (!root || root.dataset.wldInit === 'true') return;
  root.dataset.wldInit = 'true';

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}

  var locale = root.dataset.locale || 'fr-FR';
  var currency = root.dataset.currency || 'EUR';
  var isEn = root.dataset.en === 'true';
  var btnText = root.dataset.btnText || 'Ajouter au panier';
  var variantIdInput = root.querySelector('[data-variant-id]');
  var submitBtn = root.querySelector('[data-submit]');
  var galleryMain = root.querySelector('[data-gallery-main]');
  var priceEl = root.querySelector('[data-price]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var freeMsg = root.querySelector('[data-free-msg]');
  var thumbs = root.querySelectorAll('.wld-p-thumb');

  function money(cents) {
    return (cents / 100).toLocaleString(locale, { style: 'currency', currency: currency });
  }

  function showMedia(mediaId) {
    if (!galleryMain || !mediaId) return;
    galleryMain.querySelectorAll('.wld-p-media-item').forEach(function (item) {
      var isMatch = item.dataset.mediaId === String(mediaId);
      item.classList.toggle('is-active', isMatch);
      var video = item.querySelector('video');
      if (video && !isMatch) video.pause();
    });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaTarget === String(mediaId)); });
  }

  // Shipping estimate (working days, Mon-Fri)
  var ship = root.querySelector('[data-ship]');
  if (ship) {
    var addWorkingDays = function (date, n) {
      var d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); var day = d.getDay(); if (day !== 0 && day !== 6) n--; }
      return d;
    };
    var now = new Date();
    var fmt = { day: 'numeric', month: 'long' };
    var d1 = addWorkingDays(now, parseInt(ship.dataset.min, 10) || 9).toLocaleDateString(locale, fmt);
    var d2 = addWorkingDays(now, parseInt(ship.dataset.max, 10) || 18).toLocaleDateString(locale, fmt);
    ship.querySelector('[data-ship-dates]').textContent = isEn ? ' between ' + d1 + ' and ' + d2 : ' entre le ' + d1 + ' et le ' + d2;
  }

  function updateFreeMsg(price) {
    if (!freeMsg) return;
    var threshold = parseInt(freeMsg.dataset.threshold, 10);
    if (price >= threshold) {
      freeMsg.textContent = isEn ? 'Free delivery on this item, with tracking.' : 'Livraison offerte pour cet article, avec suivi.';
    } else if (!isEn) {
      freeMsg.textContent = 'Plus que ' + money(threshold - price) + ' pour la livraison offerte.';
    }
  }

  var optionGroups = root.querySelectorAll('.wld-p-option');
  var selected = [];
  optionGroups.forEach(function (group, idx) {
    var activeBtn = group.querySelector('.wld-p-pill.is-active');
    selected[idx] = activeBtn ? activeBtn.dataset.value : null;
  });

  function matches(v, sel) {
    var opts = [v.option1, v.option2, v.option3];
    return sel.every(function (val, i) { return val === null || opts[i] === val; });
  }

  function updateAvailability() {
    optionGroups.forEach(function (group, idx) {
      group.querySelectorAll('.wld-p-pill').forEach(function (pill) {
        var test = selected.slice();
        test[idx] = pill.dataset.value;
        var match = variants.find(function (v) { return matches(v, test); });
        pill.classList.toggle('is-unavailable', !match || !match.available);
      });
    });
  }

  function applyVariant() {
    var variant = variants.find(function (v) { return matches(v, selected); });
    if (!variant) return;
    variantIdInput.value = variant.id;
    if (variant.available) {
      submitBtn.removeAttribute('disabled');
      submitBtn.textContent = isEn ? 'Add to cart' : btnText;
    } else {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = isEn ? 'Sold out' : 'Épuisé';
    }
    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += '<s class="wld-p-price__compare">' + money(variant.compare_at_price) + '</s>';
    }
    html += '<span class="wld-p-price__now">' + money(variant.price) + '</span>';
    if (priceEl) priceEl.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    updateFreeMsg(variant.price);
    if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    updateAvailability();
  }

  optionGroups.forEach(function (group) {
    var pills = group.querySelectorAll('.wld-p-pill');
    var current = group.querySelector('.wld-p-option__current');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('is-unavailable')) return;
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        if (current) current.textContent = pill.dataset.value;
        selected[parseInt(pill.dataset.optionIndex, 10)] = pill.dataset.value;
        applyVariant();
      });
    });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { showMedia(thumb.dataset.mediaTarget); });
  });

  var qtyInput = root.querySelector('.wld-p-qty input');
  var dec = root.querySelector('[data-qty-decrease]');
  var inc = root.querySelector('[data-qty-increase]');
  if (dec) dec.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
  if (inc) inc.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

  // Sticky add-to-cart on mobile, shown once the main button scrolls out of view
  var sticky = root.querySelector('[data-sticky]');
  var stickyBtn = root.querySelector('[data-sticky-btn]');
  if (sticky && submitBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', hidden);
      sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
      stickyBtn.tabIndex = hidden ? 0 : -1;
    }).observe(submitBtn);
    stickyBtn.addEventListener('click', function () {
      if (submitBtn.disabled) return;
      submitBtn.click();
    });
  }

  updateAvailability();
})();